import React from 'react'
import {
  CFView,
  CFText,
  CFImage,
  CFLink,
  DefaultScreen,
  MobileScreen,
} from 'components'
import Header from './Header'
import OrderPickupButton from './OrderPickupButton'
import OrderDeliveryButton from './OrderDeliveryButton'
import { hero, heroText, mobileHero, mobileHeroText } from 'images'

export default () => {
  return (
    <CFView>
      <MobileScreen>
        <CFView
          h="100vh"
          w="100%"
          image={`url(${mobileHero}) bottom / cover no-repeat`}
          boxShadow="1px 1px 3px rgba(0,0,0,.6)"
          column
          alignCenter
        >
          <Header />
          <CFView textCenter w="100%">
            <CFView mt="30px" mb="20px">
              <CFImage
                w="90%"
                src={mobileHeroText}
                alt="The chef sushi hero text"
                zIndex={98}
              />
            </CFView>
            <CFView pulsate>
              <OrderPickupButton />
            </CFView>
          </CFView>
        </CFView>
      </MobileScreen>
      <DefaultScreen>
        <CFView
          h="100vh"
          maxHeight="650px"
          w="100%"
          image={`url(${hero}) 20% 0 / cover no-repeat`}
          zIndex={90}
          column
          justifyStart
        >
          <Header />
          <CFView column justifyCenter alignStart ml="70px" h="100vh">
            <CFImage
              h="230px"
              src={heroText}
              alt="The chef sushi hero text"
              zIndex={98}
            />
            <CFView mv="30px" pulsate>
              <OrderPickupButton />
            </CFView>
          </CFView>
        </CFView>
      </DefaultScreen>
    </CFView>
  )
}
